import React, { PureComponent, Fragment } from 'react';
import styles from './index.css';
import { formatVideoDuration, handleVideoProgress } from '../../../utils/util';
class ControllBar extends PureComponent {
    constructor(props) {
        super(props);
        this.timeBar = React.createRef();
        this.progressBar = React.createRef();
        this.progressBtn = React.createRef();
        this.controllBar = React.createRef();
    }
    componentDidMount() {
        if (this.controllBar.current) {
            this.controllBar.current.addEventListener('touchmove', (e) => {
                e.preventDefault();
            }, {
                passive: false
            });
        }
    }
    render() {
        const { current, total, controllShow, handleFullScreen, showFullScreenBtn } = this.props;
        // console.log('this.props', this.props)
        return (React.createElement(Fragment, null,
            React.createElement("div", { className: `${styles.controllBar}`, ref: this.controllBar, style: { bottom: controllShow ? '0px' : '-72px' }, id: "controllBar" },
                React.createElement("div", { className: styles.currentTime }, formatVideoDuration(current)),
                React.createElement("div", { className: styles.timeBar, ref: this.timeBar },
                    React.createElement("div", { className: styles.hullTimeBar }),
                    React.createElement("div", { className: styles.progressBar, style: { width: handleVideoProgress(current, total) }, ref: this.progressBar }),
                    React.createElement("div", { className: styles.progressPoint, style: { left: handleVideoProgress(current, total) }, ref: this.progressBtn })),
                React.createElement("div", { className: styles.leftTime }, formatVideoDuration(total - current)),
                showFullScreenBtn && (React.createElement("div", { className: styles.fullScreenBtn, onClick: handleFullScreen.bind(this) }))),
            React.createElement("div", { className: styles.fullTimeBar, style: { bottom: controllShow ? '-4px' : '0px' } },
                React.createElement("div", { className: styles.progressBar, style: { width: handleVideoProgress(current, total) } }))));
    }
}
export default ControllBar;
